import axios from "axios";

const bio = axios.create({
  baseURL: `http://localhost:5000`,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json;",
  },
});
const actions = {
  getVersion: async () => {
    let response = await bio.get(`api/healthcheck`);

    return response;
  },

  getVersionNew: async (context) => {
    const api = context.rootState.autenticacao.apiBioNewMultpex;
    let response = await api.get(`health`);

    return response;
  },

  getIdentification: async () => {
    let response = await bio.get(`api/capturaimagem`);

    return response;
  },

  buscarFuncionarioPorSap: async (context, { unidadeId, sap }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`/fun/unidade/${unidadeId}/funcionario`, {
      params: {
        busca: sap,
      },
    });

    return response;
  },

  verificarHealthBiometria: async (context) => {
    const api = context.rootState.autenticacao.apiBioNewMultpex;
    let response = await api.get(`health`);

    return response;
  },

  verificarHealthCheckBiometria: async () => {
    let response = await bio.get(`api/healthcheck`);
    return response;
  },

  buscarFingersUsuario: async (context, { funcionarioId }) => {
    const api = context.rootState.autenticacao.apiBioNewMultpex;
    const response = await api.get(
      `EmployeeAuth/Employee/${funcionarioId}/Fingers`
    );
    return response;
  },

  identificarBiometriaDigital: async (
    context,
    { userId, base64Image, imageWidth, imageHeight, imageResolution }
  ) => {
    const api = context.rootState.autenticacao.apiBioNewMultpex;
    try {
      const response = await api.post(`EmployeeAuth/Identify`, {
        userId,
        base64Image,
        imageWidth,
        imageHeight,
        imageResolution,
      });

      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  cadastrarBiometria: async (
    context,
    {
      employeeId,
      base64Images,
      fingerPosition,
      imageWidth,
      imageHeight,
      imageResolution,
    }
  ) => {
    const api = context.rootState.autenticacao.apiMercurio;
    const response = await api.post(`EmployeeAuth/enroll`, {
      employeeId,
      base64Images,
      fingerPosition,
      imageWidth,
      imageHeight,
      imageResolution,
    });

    return response;
  },

  cadastrarBiometriaNew: async (
    context,
    {
      employeeId,
      base64Image,
      fingerPosition,
      imageWidth,
      imageHeight,
      imageResolution,
    }
  ) => {
    const api = context.rootState.autenticacao.apiBioNewMultpex;
    const response = await api.post(`EmployeeAuth/enroll`, {
      employeeId,
      base64Image,
      fingerPosition,
      imageWidth,
      imageHeight,
      imageResolution,
    });

    return response;
  },

  verificarBiometria: async (
    context,
    { userId, base64Image, imageWidth, imageHeight, imageResolution }
  ) => {
    const api = context.rootState.autenticacao.apiMercurio;
    try {
      const response = await api.post(`EmployeeAuth/Identify`, {
        userId,
        base64Image,
        imageWidth,
        imageHeight,
        imageResolution,
      });

      return response;
    } catch (error) {
      console.log(error);
    }
  },

  verificarBiometriaNew: async (
    context,
    { userId, base64Image, imageWidth, imageHeight, imageResolution }
  ) => {
    const api = context.rootState.autenticacao.apiBioNewMultpex;
    try {
      const response = await api.post(`EmployeeAuth/Identify`, {
        userId,
        base64Image,
        imageWidth,
        imageHeight,
        imageResolution,
      });

      return response;
    } catch (error) {
      console.log(error);
    }
  },

  verificarUsuarioBiometria: async (
    context,
    { userId, base64Image, imageWidth, imageHeight, imageResolution }
  ) => {
    const api = context.rootState.autenticacao.apiMercurio;
    try {
      const response = await api.post(`EmployeeAuth/Identify`, {
        userId,
        base64Image,
        imageWidth,
        imageHeight,
        imageResolution,
      });

      return response;
    } catch (error) {
      console.log(error);
    }
  },

  receberDedosCadastrados: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiMercurio;
    const response = await api.get(`EmployeeAuth/Employee/${id}/Fingers`);

    return response;
  },

  receberDedosCadastradosNew: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiBioNewMultpex;
    const response = await api.get(`EmployeeAuth/Employee/${id}/Fingers`);

    return response;
  },

  // Teste de Biometria

  cadastrarBiometriaTeste: async (
    context,
    { funcionarioId, indiceDedo, imagem, altura, largura, resolucao }
  ) => {
    const api = context.rootState.autenticacao.apiBioMultpex;
    const response = await api.post(`digital/cadastro`, {
      funcionarioId,
      indiceDedo,
      imagem,
      altura,
      largura,
      resolucao,
    });

    return response;
  },

  verificarBiometriaTeste: async (
    context,
    { funcionarioId, indiceDedo, imagem, altura, largura, resolucao }
  ) => {
    const api = context.rootState.autenticacao.apiBioMultpex;
    const response = await api.post(`digital/verificacao`, {
      funcionarioId,
      indiceDedo,
      imagem,
      altura,
      largura,
      resolucao,
    });

    return response;
  },

  verificarBiometriaDedosCadastrados: async (context, { funcionarioId }) => {
    const api = context.rootState.autenticacao.apiBioMultpex;
    const response = await api.get(`digital/coletarBiometriasCadastradas`, {
      params: {
        funcionarioId,
      },
    });

    return response;
  },
};

export const biometria = {
  namespaced: true,
  actions,
};
